import { metadata } from '../Network/MetaTypes'
import { MapLike } from '../core'
import { PayloadMessageType } from './PayloadMessageType'

export const getPayloadMessage = <T extends MapLike<any>>(unpackedDevicePayload: { [k in keyof T]?: any }, meta: metadata): PayloadMessageType => {
  const messageBase: PayloadMessageType = {
    state: {
      reported: {
        meta: {} as metadata,
      },
    },
  }

  if (meta.deviceId) {
    meta.deviceId = meta.deviceId.toUpperCase()
  }

  Object.assign(messageBase.state.reported, unpackedDevicePayload)
  Object.assign(messageBase.state.reported.meta ?? {}, meta)

  return messageBase
}
